<script setup>
import { computed } from 'vue';
import { useToggle } from '@vueuse/core';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultOpen: {
    type: Boolean,
    default: false,
  },
  /** When set, accordion open state is controlled by the parent. */
  open: {
    type: Boolean,
    default: undefined,
  },
});

const emit = defineEmits(['toggle']);

const [internalOpen, toggleInternal] = useToggle(props.defaultOpen);

const isControlled = computed(() => props.open !== undefined);

const isOpen = computed(() =>
  isControlled.value ? props.open : internalOpen.value
);

const onHeaderClick = () => {
  if (isControlled.value) {
    emit('toggle');
  } else {
    toggleInternal();
  }
};
</script>

<template>
  <div v-bind="$attrs" class="border-t border-n-weak first:border-t-0">
    <button
      type="button"
      class="flex w-full cursor-pointer items-center justify-between gap-2 pb-2 pt-4 text-start"
      @click="onHeaderClick"
    >
      <span class="w-full text-heading-2 text-n-slate-12">
        {{ title }}
      </span>
      <Icon
        icon="i-lucide-chevron-down"
        class="size-5 shrink-0 text-n-slate-11 transition-transform duration-200"
        :class="isOpen ? 'rotate-180' : ''"
      />
    </button>
    <div v-if="isOpen" class="mb-4 w-full space-y-4 pt-2">
      <slot />
    </div>
  </div>
</template>
